// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/sharing/v2/sharing.v2.proto (package no.jotta.openapi.sharing.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { DeclineShareRequest, DeclineShareResponse, DisableFolderShareRequest, DisableFolderShareResponse, DisableShareRequest, DisableShareResponse, EnableShareRequest, EnableShareResponse, GetAddressBookRequest, GetAddressBookResponse, GetShareInfoRequest, GetShareInfoResponse, InviteMemberRequest, InviteMemberResponse, JoinShareRequest, JoinShareResponse, LeaveShareRequest, LeaveShareResponse, ListFolderSharesRequest, ListFolderSharesResponse, ListPendingInvitesRequest, ListPendingInvitesResponse, RemoveMemberRequest, RemoveMemberResponse } from "./sharing.v2_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * Enable public sharing of a file or folder
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.EnablePublicShare
 */
export const enablePublicShare = {
    localName: "enablePublicShare",
    name: "EnablePublicShare",
    kind: MethodKind.Unary,
    I: EnableShareRequest,
    O: EnableShareResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Disable public sharing of a file or folder
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.DisablePublicShare
 */
export const disablePublicShare = {
    localName: "disablePublicShare",
    name: "DisablePublicShare",
    kind: MethodKind.Unary,
    I: DisableShareRequest,
    O: DisableShareResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Gets extended sharing information about the given path, such as members and their names.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.GetShareInfo
 */
export const getShareInfo = {
    localName: "getShareInfo",
    name: "GetShareInfo",
    kind: MethodKind.Unary,
    I: GetShareInfoRequest,
    O: GetShareInfoResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * InviteMember sends an invite to the given email.
 * The given path must be a folder under /Sync, must be owned by the user and
 * can not be shared if any parent path is already part of a share.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.InviteMember
 */
export const inviteMember = {
    localName: "inviteMember",
    name: "InviteMember",
    kind: MethodKind.Unary,
    I: InviteMemberRequest,
    O: InviteMemberResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Join share joins the share identified by the given inviteKey.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.JoinShare
 */
export const joinShare = {
    localName: "joinShare",
    name: "JoinShare",
    kind: MethodKind.Unary,
    I: JoinShareRequest,
    O: JoinShareResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Decline declines a share invitation. This action can not be undone.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.DeclineShare
 */
export const declineShare = {
    localName: "declineShare",
    name: "DeclineShare",
    kind: MethodKind.Unary,
    I: DeclineShareRequest,
    O: DeclineShareResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * LeaveShare leaves the share identified by the given shareId.
 * You must be member to leave the share.
 * Share owners can remove all members by using RemoveMember call.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.LeaveShare
 */
export const leaveShare = {
    localName: "leaveShare",
    name: "LeaveShare",
    kind: MethodKind.Unary,
    I: LeaveShareRequest,
    O: LeaveShareResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Removes the given username as member of the given folder share.
 * Can also remove the invitation sent to the given email.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.RemoveMember
 */
export const removeMember = {
    localName: "removeMember",
    name: "RemoveMember",
    kind: MethodKind.Unary,
    I: RemoveMemberRequest,
    O: RemoveMemberResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Removes all members and invitations and disables the given folder share
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.DisableFolderShare
 */
export const disableFolderShare = {
    localName: "disableFolderShare",
    name: "DisableFolderShare",
    kind: MethodKind.Unary,
    I: DisableFolderShareRequest,
    O: DisableFolderShareResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * AddressBook is useful to offer some suggestions or auto complete for the invitation UI.
 * It will include f.ex. any family members.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.GetAddressBook
 */
export const getAddressBook = {
    localName: "getAddressBook",
    name: "GetAddressBook",
    kind: MethodKind.Unary,
    I: GetAddressBookRequest,
    O: GetAddressBookResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Returns a list of pending share invites for your account.
 *
 *        option (google.api.http) = {
 *            post: "/shares/v2/list_pending_invites"
 *            body: "*"
 *        };
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.ListPendingInvites
 */
export const listPendingInvites = {
    localName: "listPendingInvites",
    name: "ListPendingInvites",
    kind: MethodKind.Unary,
    I: ListPendingInvitesRequest,
    O: ListPendingInvitesResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Returns information on all your active folder shares.
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.ListFolderShares
 */
export const listFolderShares = {
    localName: "listFolderShares",
    name: "ListFolderShares",
    kind: MethodKind.Unary,
    I: ListFolderSharesRequest,
    O: ListFolderSharesResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.sharing.v2.SharingService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.sharing.v2.SharingService"
    }
};
